import { Card } from '../styles/CardStyles';

const MissionVisionCard = ({ type, icon, titleIcon, title, description }) => {
  return (
    <Card className={type}>
      <div className="card-icon">
        <i className={icon}></i>
      </div>
      <h3>
        <i className={titleIcon}></i>
        {title}
      </h3>
      <p>{description}</p>
    </Card>
  );
};

export default MissionVisionCard;
